"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SceneSwitcher = void 0;
const inversify_1 = require("inversify");
const SymbolClasses_1 = require("../Utils/SymbolClasses");
const Animation_1 = require("../Common/Animation/Animation");
let SceneSwitcher = class SceneSwitcher {
    constructor(stage, events) {
        this.stage = stage;
        this.events = events;
    }
    switch(from, to, outTime = 0.6, inTime = 0.6, inDelay = 0) {
        const outAnim = new Animation_1.AnimationManager(Animation_1.CreatePixiPropSetter(from));
        const inAnim = new Animation_1.AnimationManager(Animation_1.CreatePixiPropSetter(to));
        to.alpha = 0;
        outAnim.animations.set("alpha", Animation_1.createSimpleAnimation(1, 0, outTime, Animation_1.keyFramePresets.easeOut));
        inAnim.animations.set("alpha", Animation_1.createSimpleAnimation(0, 1, inTime, Animation_1.keyFramePresets.easeOut));
        this.events.Update.add((remove, dt) => {
            if (outAnim.ended)
                return remove();
            outAnim.update(dt);
            if (outAnim.currentTime > inDelay)
                inAnim.update(dt);
        });
        const i = this.stage.getChildIndex(from);
        this.stage.addChildAt(to, i);
        outAnim.onEnd.add(() => {
            this.stage.removeChild(from);
        });
        return {
            inEnd: inAnim.onEnd,
            outEnd: outAnim.onEnd,
        };
    }
};
SceneSwitcher = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [SymbolClasses_1.MainStage, SymbolClasses_1.GlobalEvents])
], SceneSwitcher);
exports.SceneSwitcher = SceneSwitcher;
//# sourceMappingURL=SceneSwitcher.js.map